import { render, staticRenderFns } from "./order-detail-pdf.vue?vue&type=template&id=f1053a7e&"
import script from "./order-detail-pdf.vue?vue&type=script&lang=js&"
export * from "./order-detail-pdf.vue?vue&type=script&lang=js&"
import style0 from "./order-detail-pdf.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports